import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalLoadingComponent } from './core/loading/global-loading.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    GlobalLoadingComponent
  ],
  template: `
    <router-outlet />
    <app-global-loading />
  `
})
export class App {}